import React, { useEffect, useState } from "react";
import CardService from "../../../components/cardservice/CardService";
import axios from "axios";
import "./Finance.scss";

import usePaginations from "../../../Paginations";
import Contant from "../../../Contant";
import { Pagination } from "@mui/material";

const Fimance = (props) => {
  const [datas, setDatas] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios({
        method: "get",
        url: Contant + "api/posts?type=products",
        Headers: {
          Accept: "application.json",
          "Content-Type": "application/json",
        },
      });

      if (response.data.products.finance === undefined) {
        setDatas(datas);
      } else {
        setDatas(response.data.products.finance);
      }
    };
    fetchData();
  }, [props]);

  let [page, setPage] = useState(1);
  const PER_PAGE = 1;

  const count = Math.ceil(datas.length / PER_PAGE);
  var _DATA = usePaginations(datas, PER_PAGE);

  // console.log(_DATA)

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <div className="Main_style_serviceTop_element_finance">
      <div className="style_frame_main_cards_service">
        <div className="frame_service_items">
          {_DATA.currentDatas().map((item, index) => (
            <div key={index}>
              <CardService
                Title={item.title}
                image={Contant + "api/data/images/" + item.coverPhoto}
                date={item.date}
                id={item.id}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="frame_piantion">
        <Pagination
          count={count}
          size="small"
          page={page}
          variant="outlined"
          shape="rounded"
          onChange={handleChange}
        />
      </div>

      {/* <LoanService/> */}
    </div>
  );
};

export default Fimance;
